// 9fbef606107a605d69c0edbcd8029e5d 
const SIZE_CHART_LINK_POSITIONS = {
  AFTER_SIZE: 2,
  AFTER_QUANTITY: 3,
};

export const MULTI_PACK_TYPE = {
  SINGLE: '0001',
  MULTIPACK: '0002',
  SET: '0003',
};
export default SIZE_CHART_LINK_POSITIONS;
